module.exports = __webpack_public_path__ + "static/media/1417961381.ea3fdfa6.ttf";